/**
 * A dynamic modal component that can be used anywhere with dynamic values.
 *
 * @param {boolean} show - Determines whether the modal is visible or hidden.
 * @param {function} onHide - Callback function to handle the modal close event.
 * @param {string} title - The title of the modal.
 * @param {string} body - The content of the modal body.
 * @param {string} primaryButtonText - The text for the primary button.
 * @param {string} secondaryButtonText - The text for the secondary button.
 * @param {function} onPrimaryButtonClick - Callback function to handle the primary button click event.
 * @param {function} onSecondaryButtonClick - Callback function to handle the secondary button click event.
 * @returns {JSX.Element} - The dynamic modal component.
 */
const DynamicModal = ({
    show,
    onHide,
    title,
    body,
    primaryButtonText,
    secondaryButtonText,
    onPrimaryButtonClick,
    onSecondaryButtonClick
}) => {
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{body}</Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={onSecondaryButtonClick}>
                    {secondaryButtonText}
                </Button>
                <Button variant="success" onClick={onPrimaryButtonClick}>
                    {primaryButtonText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DynamicModal;
